jQuery(function($) {
  $(document).ready(function () {
    $('.yearArchiveList li').on("click", function(){
      if( $(this).hasClass('open')) {
        $(this).removeClass('open');
      } else {
        $(this).addClass('open');
      }

      $(this).find('.eachYear').slideToggle(400);
    });
  });
});
